import { AnyConceptStatusesByCid, ConceptStatusValueType, FusionError, ImportWriteMode, serializeFusionError } from '@fusion-advantage/backcompat'
import {
	ConceptStatusUpdate,
	getConceptStatusValue,
	importLabRecommendations,
	importLabResults,
	LabRecommendationsConcept,
	LabResultsConcept,
	LabsConcept,
	RLabItem,
	RLabRecommendationItem,
	RLabResultItem,
} from "@fusion-advantage/formlib"
import { FormRootState, FormThunk } from "../../redux/formStore"
import { loadLabs } from "../../redux/labsSlice"
import { err, ok, Result } from "neverthrow"
import z from "zod"
import { ComplexModelReduxPersister } from "./ComplexModelReduxPersister"

export class LabModelReduxPersister implements ComplexModelReduxPersister {
	loadFromStatuses = (statusesByCid: AnyConceptStatusesByCid): FormThunk<Result<void, FusionError>> => (dispatch, getState) => {
		const valueForCid = (cid: string) => getConceptStatusValue(statusesByCid[cid]) ?? []
		const rReco = z.array(RLabRecommendationItem).safeParse(valueForCid(LabRecommendationsConcept.cid))
		if(!rReco.success) {
			return err(serializeFusionError('LabModelReduxPersister rReco', rReco.error))
		}
		const rResult = z.array(RLabResultItem).safeParse(valueForCid(LabResultsConcept.cid))
		if(!rResult.success) {
			return err(serializeFusionError('LabModelReduxPersister rResult', rResult.error))
		}
		const rLabs = z.array(RLabItem).safeParse(valueForCid(LabsConcept.cid))
		if(!rLabs.success) {
			return err(serializeFusionError('LabModelReduxPersister rLabs', rLabs.error))
		}
		let models = importLabRecommendations(rReco.data, rLabs.data)
		// 20250129 Dan asks not to merge in results
		// unless the form is in full write mode
		if(getState().render.form?.writeMode === ImportWriteMode.WriteAll) {
			models = importLabResults(rResult.data, models ?? [])
		}
		dispatch(loadLabs({
			models,
			recommendations: rReco.data,
		}))
		return ok()
	}
	shouldSave(prevState: FormRootState, nextState: FormRootState) {
		return prevState.labs.models !== nextState.labs.models
	}
	createStatusUpdates(nextState: FormRootState): ConceptStatusUpdate[] {
		return [{
			cid: LabsConcept.cid,
			value: nextState.labs.models,
			// must be .Chosen to be picked up by formDraftMiddleware
			// for auto draft save
			valueType: ConceptStatusValueType.Chosen,
		}]
	}
}
